import { createSlice } from "@reduxjs/toolkit";

export const deliveriesAdmin = createSlice({
  name: "deliveriesAdmin",
  initialState: {
    value: false,
  },
  reducers: {
    setDeliveriesAdmin: (state, { payload }) => {
      state.value = payload;
    },
  },
});

export const { setDeliveriesAdmin } = deliveriesAdmin.actions;
export default deliveriesAdmin.reducer;
